<template>
    <div class="page restaurant-list">
        <div class="head fixed-search" @touchmove.prevent>
            <div class="top">
                <div class="content">
                    <div class="left" @click="toSetCity">
                        <div class="text">{{ initCity.city.name }}</div>
                        <img class="arrow" src="@/assets/icons/icon-down.png" />
                    </div>
                    <div class="right">
                        <input type="text" class="right-input" v-model="kw" placeholder="请输入关键字搜索" />
                    </div>

                    <div class="close-btn" v-if="kw" @click="clearKw">
                        <img class="close-img" src="@/assets/img/clear_icon.png" />
                    </div>
                </div>
            </div>
        </div>
        <div class="con-list">
            <div
                class="list"
                v-for="(item, index) in queryData"
                :class="[
                    // { 'not-open': item.displayStatus != 1 && !item.bookingTimeRange },
                    { reservation: item.displayStatus != 1 && item.bookingTimeRange },
                ]"
                :key="index"
                v-if="queryData.length > 0"
            >
                <div class="left" @click="toMenu(index)">
                    <div class="name">
                        <div class="text">{{ item.storeName }}</div>
                        <div class="status"></div>
                    </div>
                    <div class="addr">{{ item.address }}</div>
                    <div class="line">
                        <div class="num" v-if="showDistance">{{ item.distance }}</div>
                        <div class="booking-time" v-if="item.bookingTimeRange">可预约：{{ item.bookingTimeRange }}</div>
                        <div class="delivery-time" v-if="item.deliveryTime">
                            预计送达时间：{{ item.deliveryTime }}分钟
                        </div>
                    </div>
                </div>
                <div class="right" @click="changeLove(index)">
                    <img class="love" src="@/assets/icons/icon-start-02.png" v-if="item.isFavorite" />
                    <img class="love" src="@/assets/icons/icon-start-01.png" v-if="!item.isFavorite" />
                </div>
            </div>
            <div v-if="isLoading && queryData.length < 1" class="none-length">餐厅加载中...</div>
            <div v-else-if="loadError && queryData.length < 1" class="none-length load-error">
                <div>{{ loadError }}</div>
                <button type="button" @click="init(1)">重新加载</button>
            </div>
            <div v-else-if="queryData.length < 1" class="none-length">暂无搜索结果！</div>
        </div>

        <Scroll :onBottom="onBottom" :lowerThreshold="600" />
    </div>
</template>
<script>
import { GET_NEARBY_TAKEOUT_STOP, SET_LOVE_STOP } from 'api';
import { PAGE_SET_CITY, PAGE_STOP_MENU } from 'page';
import Scroll from '@/components/scroll';
export default {
    data() {
        return {
            type: 0, // 10 堂食切换门店 // 11 宅急送切换门店
            storeType: 1, // 餐厅类型 1:普通 2:肯悦 3:轻食

            isIniting: false,
            isLoading: false,
            loadError: '',
            requestId: 0,

            current: 0,
            queryData: [],
            restaurantNum: {
                favorite: 0,
                nearby: 0,
            },
            kw: '',
            pageIndex: 1,
            pageSize: 20,
            isBottom: false,
            conHeight: 0,
            isFixedSearch: false,
        };
    },
    computed: {
        cityId() {
            return this.$store.getters.getCurrentLocation.city.id;
        },
        userId() {
            return this.$store.state.user.userInfo.id || null;
        },
        initCity() {
            return this.$store.getters.getCurrentLocation;
        },
        showDistance() {
            if (this.addressId) {
                return true;
            } else if (this.$store.state.location.currentLocation.lon) {
                return true;
            } else {
                return false;
            }
        },
        isHasLocation() {
            return this.$store.state.location.isHasLocation;
        },
    },
    watch: {
        kw(val) {
            this.$util.debounce(this.getStoreList, 500, false)();
        },
        cityId(val) {
            // 非宅急送场景依赖定位；定位晚于页面创建时，主动补发首次请求。
            if (val && this.pageType != 11 && this.queryData.length == 0) {
                this.init(1);
            }
        },
    },
    components: {
        Scroll,
    },
    created() {
        this.pageType = this.$route.query.type || 0;
        this.addressId = this.$route.query.addressId || 0;
        this.bookingTime = this.$route.query.bookingTime || null;
        this.storeType = this.$route.query.storeType || 1;
        // 宅急送切换餐厅只依赖 addressId，不应被异步定位阻塞。
        if ((this.pageType == 11 && this.addressId) || this.cityId) {
            this.init();
        } else if (this.pageType == 11) {
            this.loadError = '缺少收货地址信息，请返回后重新选择地址。';
        }
    },
    methods: {
        // init
        init(type = 0) {
            if (this.isIniting) {
                return;
            }
            this.isIniting = true;
            if (this.$store.state.location.currentLocation.city.id) {
                this.pageLocation = this.$store.state.location.currentLocation;
            } else {
                this.pageLocation = this.$store.state.location.selectLocation;
            }
            if (this.pageType != 11 && !this.cityId) {
                this.isIniting = false;
                return;
            }
            this.getData(type).then(() => {
                this.isIniting = false;
            });
        },
        getStoreList() {
            this.getData(1);
        },
        // 获取餐厅
        getData(type = 0) {
            let url = '';
            let requestData = {};
            let requestType = '';
            if (type == 1) {
                this.pageIndex = 1;
            }
            if (this.pageType == 11) {
                url = GET_NEARBY_TAKEOUT_STOP;
                requestData = {
                    addressId: this.$route.query.addressId,
                    bookingTime: this.$route.query.bookingTime,
                    storeType: this.storeType,
                    kw: this.kw,
                };
                requestType = 'post';
            }

            if (!requestType || !url) {
                this.loadError = '当前餐厅切换方式不受支持。';
                return Promise.resolve();
            }

            const requestId = ++this.requestId;
            this.isLoading = true;
            this.loadError = '';
            return this.$util[requestType](url, requestData).then(res => {
                // 搜索或重新加载可能产生并发请求，只允许最后一次请求更新页面。
                if (requestId != this.requestId) {
                    return;
                }
                if (res.success && Array.isArray(res.data)) {
                    if (this.pageType == 11 || res.data.length < this.pageSize) {
                        this.isBottom = true;
                    } else {
                        this.isBottom = false;
                    }
                    if (type == 1) {
                        this.queryData = [];
                    }
                    if (this.kw) {
                        document.getElementsByClassName('head')[0].scrollIntoView();
                    }
                    this.queryData = this.$util.distinct([...this.queryData, ...res.data], 'storeCode');
                } else {
                    this.loadError =
                        res && typeof res.message == 'string' && res.message
                            ? res.message
                            : '餐厅加载失败，请稍后重试。';
                }
            }).catch(error => {
                if (requestId == this.requestId) {
                    console.error('restaurant-list', 'getData', error);
                    this.loadError = '餐厅加载失败，请稍后重试。';
                }
            }).then(() => {
                if (requestId == this.requestId) {
                    this.isLoading = false;
                }
            });
        },
        // 收藏餐厅
        changeLove(index) {
            this.queryData[index].isFavorite = !this.queryData[index].isFavorite;
            if (this.queryData[index].isFavorite) {
                this.restaurantNum.favorite++;
            } else {
                this.restaurantNum.favorite--;
            }
            this.$util
                .post(SET_LOVE_STOP, {
                    storeCode: this.queryData[index].storeCode,
                    favorite: this.queryData[index].isFavorite,
                })
                .then(res => {
                    if (!res.success) {
                        if (!this.queryData[index].isFavorite) {
                            this.restaurantNum.favorite++;
                        } else {
                            this.restaurantNum.favorite--;
                        }
                        this.queryData[index].isFavorite = !this.queryData[index].isFavorite;
                    }
                });
        },
        // 切换餐厅
        changeSelect(index) {
            if (this.current == index) {
                return;
            }
            this.current = index;
            this.pageIndex = 1;
            this.getData(1);
        },
        // 去餐厅商品
        toMenu(index) {
            let path = '';
            let query = {};
            let config = {};
            if (this.pageType == 11) {
                path = PAGE_STOP_MENU;
                query = {
                    storeCode: this.queryData[index].storeCode,
                    bookingTime: this.$route.query.bookingTime,
                    addressId: this.$route.query.addressId,
                    storeType: this.storeType,
                    type: 1,
                };
                config = {
                    jumpType: 1,
                };
            }

            if (path) {
                this.$util.pageJump({
                    path,
                    query,
                    config,
                });
            }
        },
        // 选择城市
        toSetCity() {
            this.$util.pageJump(PAGE_SET_CITY);
        },
        // 清除查询内容
        clearKw() {
            this.kw = '';
        },
        scrollToTop() {
            if (!this.conHeight) {
                if (this.$refs.con) {
                    this.conHeight = this.$refs.con.offsetHeight;
                } else {
                    return;
                }
            }

            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            if (scrollTop > this.conHeight) {
                this.isFixedSearch = true;
            } else {
                this.isFixedSearch = false;
            }
        },
        // 触底事件
        onBottom() {
            if (this.isBottom || this.isLoading || this.pageType == 11) {
                return;
            }
            this.pageIndex++;
            this.getData();
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
.head {
    &.fixed-search {
        > .top {
            position: fixed;
            top: 0;
            z-index: 100;
        }
        > .tab {
            position: fixed;
            top: .pxToRem(98) [];
            z-index: 100;
        }
    }
}

.top {
    background: #f0f0f0;
    padding: .pxToRem(20) [] .pxToRem(20) [];
    .content {
        position: relative;
        padding: 0 .pxToRem(34) [];
        margin: 0 auto;
        width: .pxToRem(710) [];
        height: .pxToRem(68) [];
        line-height: .pxToRem(68) [];
        background-color: #ffffff;
        border-radius: .pxToRem(34) [];
        display: flex;
        justify-content: flex-start;
        border: 1px solid #e9e9e9;
        box-sizing: border-box;
        .left {
            min-width: .pxToRem(122) [];
            display: flex;
            .text {
                font-size: .pxToRem(28) [];
                max-width: .pxToRem(112) [];
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.9);
            }
            .arrow {
                .sq(24);
                margin-left: .pxToRem(16) [];
                margin-right: .pxToRem(16) [];
                margin-top: .pxToRem(20) [];
            }
        }
        .right {
            flex: 1;
            height: .pxToRem(68) [];
            .right-input {
                position: absolute;
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
                width: 100%;
                height: .pxToRem(68) [];
                line-height: .pxToRem(68) [];
                font-size: .pxToRem(26) [];
                background: none;
            }
        }
    }
}

.con-list {
    margin-top: .pxToRem(108) [];
    width: 100%;
    .none-length {
        width: 100%;
        height: .pxToRem(400) [];
        line-height: .pxToRem(400) [];
        text-align: center;

        &.load-error {
            box-sizing: border-box;
            padding-top: .pxToRem(120) [];
            color: #71757b;
            line-height: .pxToRem(44) [];

            button {
                min-width: .pxToRem(180) [];
                height: .pxToRem(68) [];
                margin-top: .pxToRem(24) [];
                padding: 0 .pxToRem(28) [];
                color: #ffffff;
                font-size: .pxToRem(26) [];
                border: 0;
                border-radius: .pxToRem(34) [];
                background: #d71920;
            }
        }
    }
    .list {
        .jc-sb;
        width: .pxToRem(710) [];
        margin: 0 auto;
        margin-bottom: .pxToRem(10) [];
        background: white;
        box-shadow: .pxToRem(3) [] .pxToRem(3) [] .pxToRem(8) [] 0px rgba(0, 0, 0, 0.1);
        border-radius: .pxToRem(30) [];
        .left {
            width: .pxToRem(620) [];
            box-sizing: border-box;
            padding-left: .pxToRem(30) [];
            .name {
                display: flex;
                justify-content: flex-start;
                font-size: .pxToRem(30) [];
                font-weight: 600;
                height: .pxToRem(40) [];
                line-height: .pxToRem(40) [];
                margin-top: .pxToRem(20) [];
                align-items: center;
                .text {
                    max-width: .pxToRem(480) [];
                    .overflow(1);
                    margin-right: .pxToRem(12) [];
                }
                .status {
                    width: .pxToRem(80) [];
                    height: .pxToRem(32) [];
                    background: url('~@/assets/icons/icon-display-status-1.png');
                    background-size: cover;
                    background-repeat: no-repeat;
                }
            }
            .addr {
                font-size: .pxToRem(24) [];
                color: rgba(0, 0, 0, 0.5);
                line-height: .pxToRem(36) [];
                margin-top: .pxToRem(6) [];
                margin-bottom: .pxToRem(8) [];
            }
            .line {
                display: flex;
                padding-bottom: .pxToRem(12) [];
            }
            .num {
                // margin-bottom: .pxToRem(12) [];
                font-size: .pxToRem(24) [];
                color: rgba(0, 0, 0, 0.9);
                height: .pxToRem(36) [];
                line-height: .pxToRem(36) [];
                text-indent: .pxToRem(42) [];
                &:after {
                    content: ' ';
                    .base-center-y;
                    left: 0;
                    .sq(24);
                    background: url('~@/assets/icons/icon-location-map.png');
                    background-size: cover;
                }
            }
            .booking-time,
            .delivery-time {
                display: none;
                font-size: .pxToRem(26) [];
                color: rgba(0, 0, 0, 0.9);
                height: .pxToRem(36) [];
                line-height: .pxToRem(36) [];
                font-weight: bold;
            }
            .delivery-time {
                display: block;
            }
            .num + .booking-time,
            .num + .delivery-time {
                margin-left: .pxToRem(12) [];
                &::before {
                    content: '|';
                    margin-right: .pxToRem(12) [];
                }
            }
        }
        .right {
            text-align: right;
            position: relative;
            .love {
                position: absolute;
                top: .pxToRem(24) [];
                right: .pxToRem(40) [];
                .sq(32);
            }
        }
        &.not-open {
            filter: grayscale(100%);
            .left {
                .name {
                    font-weight: 400;
                    .text {
                        color: rgba(0, 0, 0, 0.5);
                        display: flex;
                        align-items: center;
                    }
                    .status {
                        background: url('~@/assets/icons/icon-display-status-0.png');
                        background-size: cover;
                        background-repeat: no-repeat;
                    }
                }
                .num {
                    color: rgba(0, 0, 0, 0.5);
                }
            }
        }
        &.reservation {
            .left {
                .name {
                    .status {
                        width: .pxToRem(122) [];
                        background: url('~@/assets/icons/icon-display-status-2.png');
                        background-size: cover;
                        background-repeat: no-repeat;
                    }
                }
                .line {
                    .booking-time {
                        display: block;
                    }
                }
            }
        }
    }
}
</style>
